<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
// import Vue from 'vue'

import Stat from "@/components/widgets/stat";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Stat
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "Dashboard",
          active: true,
        },
      ],

      isLoading: false,

        center: { 
            lat:"", 
            lng: "" 
            
         },
         locations: [],
         currentLocation: null,
         markerOptions: {
            url: require('@/assets/images/truck1.png'),
            size: {width: 50, height: 50, f: 'px', b: 'px'},
            scaledSize: {width: 50, height: 50, f: 'px', b: 'px'},
         },
         showByIndex: null,

 
      pieChart: {
        series: [],
        chartOptions: {
          labels: [
            "Pending",
            "Accepted",
            "On going",
            "scheduled",
            "Cancelled",
            "Delivered",
            "Missed",
          ],
          colors: [
            "#8b9ef5",
            "#f7e860",
            "#cb86d7",
            "#e91e63",
            "#f46a6a",
            "#34c38f",
            "#e14f80",
          ],
          legend: {
            show: true,
            position: "bottom",
            horizontalAlign: "center",
            verticalAlign: "middle",
            floating: false,
            fontSize: "14px",
            offsetX: 0,
          },
          responsive: [
            {
              breakpoint: 600,
              options: {
                chart: {
                  height: 240,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
        },
      }, // pieChart ends

      splineAreaChart: {
        series: [
          {
            name: "Orders",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,

            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 3,
          },
          colors: ["#556ee6"],
          xaxis: {
            type: "month",
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          tooltip: {
            x: {
              format: "dd/MM/yy HH:mm",
            },
          },
        },
      },

      splineAreaChart2: {
        series: [
          {
            name: "Customers",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,

            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 3,
          },
          colors: ["#556ee6"],
          xaxis: {
            type: "month",
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          tooltip: {
            x: {
              format: "dd/MM/yy HH:mm",
            },
          },
        },
      },

      pieChart2: {
        series: [],
        chartOptions: {
          labels: ["Gasoline", "Diesel"],
          colors: ["#f7e860", "#34c38f"],
          legend: {
            show: true,
            position: "bottom",
            horizontalAlign: "center",
            verticalAlign: "middle",
            floating: false,
            fontSize: "14px",
            offsetX: 0,
          },
          responsive: [
            {
              breakpoint: 600,
              options: {
                chart: {
                  height: 240,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
        },
      }, // pieChart ends

      total_customers: 0,
      total_drivers: 0,
      total_fuel_stations: 0,
      total_orders: 0,
      total_sales: 0,
      total_earnings: 0,
      today_orders: 0,
      total_orders_week: 0,
      total_orders_month: 0,
      alerts_count: 0,
      alerts: [],
      
      requested: 0,
      pending: 0,
      accepted: 0,
      ongoing: 0,
      scheduled: 0,
      delivered: 0,
      cancelled: 0,
      missed: 0,
      diesel: 0,
      gasoline: 0,
    };
  },
  mounted() {
  },

  created() {
    this.fetchDashboard();
  },

  methods: {
    setPlace(loc) {
      this.currentLocation = loc;
    },
    /* setLocationLatLng: function () {
       navigator.geolocation.getCurrentPosition(geolocation => {
          this.center = {
      lat: geolocation.coords.latitude,
             lng: geolocation.coords.longitude
          };
      }); */

     /*  this.locations = [
        {
          latitude: this.locations.latitude,
          longitude:this.locations.longitude,
          driver_id:this.locations.driver_id,
          date:this.locations.date,

        },
        
      ];
    }, */

    fetchDashboard() {
      this.getToken();
      let url = "api/admin/dashboard";
      this.loading = true;
      this.$axios
        .get(url, { headers: { Authorization: "Bearer " + this.token } })
        .then((res) => {
          var data = res.data.data;
          console.log(data);
          console.log(res);
          if (res.status == 200) {
            console.log(data);
            this.alerts_count = data.alerts_count;
            this.total_customers = data.total_customers;
            this.total_drivers = data.total_drivers;
            this.total_fuel_stations = data.total_fuel_stations;
            this.total_orders = data.total_orders;
            if (data.total_sales && data.total_sales.total_sales) {
              this.total_sales = data.total_sales.total_sales;
            }

            if (data.total_earnings && data.total_earnings.total_earnings) {
              this.total_earnings = data.total_earnings.total_earnings;
            }

            this.today_orders = data.today_orders;
            this.total_orders_week = data.total_orders_week;
            this.total_orders_month = data.total_orders_month;
            var locations = data.driver_locations;
            this.center.lat = parseFloat(data.latitude);
            this.center.lng = parseFloat(data.longitude);

            console.log(locations);

            for(var i=0; i<locations.length; i++) {

               var name;
               if(locations[i].name_en) {
                  name = locations[i].name_en;
               } else {
                  name = locations[i].name_so;
               }
               var obj = {};

               var position = {};
               position.lat = parseFloat(locations[i].latitude);
               position.lng = parseFloat(locations[i].longitude);
               obj.position = position;

               var label = {};
               //label.text = name.charAt(0).toUpperCase() + " ";
               label.color = "#ffffff";
               label.fontWeight = "bold";
               label.fontSize = "18px";
               label.fontFamily = "";
               label.className = "";
               obj.label =  label;

               var tooltip = {};
               tooltip.content = name + "<br>" + "Order ID: ";
               if(locations[i].id) {
                  tooltip.content = tooltip.content + "#" + locations[i].id; 
               }
               obj.tooltip = tooltip;

               this.locations.push(obj);             
            }
            console.log(this.locations);


            this.splineAreaChart.series[0].data = data.completed_customer_orders;
            this.splineAreaChart2.series[0].data = data.registered_customer_month;

            this.pieChart.series[0] = data.pending;
            this.pieChart.series[1] = data.accepted;
            this.pieChart.series[2] = data.ongoing;
            this.pieChart.series[3] = data.delivered;
            this.pieChart.series[4] = data.scheduled;
            this.pieChart.series[5] = data.cancelled;
            this.pieChart.series[6] = data.missed;

            this.pieChart2.series[0] = data.gasoline;
            this.pieChart2.series[1] = data.diesel;
          } else {
            this.$swal("", "Something went wrong", "error");
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          if (error.response) {
            if (error.response.status == 422) {
              if (error.response.data) {
                this.errors = error.response.data.message;
              }
              this.$swal("", error.response.statusText, "error");
            } else if (error.response.status == 500) {
              this.$swal("", error.response.statusText, "error");
            } else if (error.response.status == 401) {
              this.$swal("", error.response.statusText, "error");
              this.$router.push({ name: "login" });
            } else {
              this.$swal("", "Something went wrong", "error");
            }
          } else {
            this.$swal("", error.message, "error");
          }
        });
    },

    getToken() {
      if (localStorage.getItem("sigofuel_admin")) {
        var sigofuel_admin = JSON.parse(localStorage.getItem("sigofuel_admin"));
        if (sigofuel_admin.token) {
          this.token = sigofuel_admin.token;
        } else {
          this.$swal("", "Failed to fetch token, please login again", "error");
          this.$router.push({ name: "login" });
        }
      } else {
        this.$swal("", "Session expired, please login again", "error");
        this.$router.push({ name: "login" });
      }
    },

    fetchAlerts() {
      this.getToken();
      let url = "api/admin/dashboard/admin_alerts";
      this.loading = true;
      this.$axios
        .get(url, { headers: { Authorization: "Bearer " + this.token } })
        .then((res) => {
          var data = res.data.data;
          console.log(data);
          console.log(res);
          if (res.status == 200) {
            
            // var alerts = data.notifications;
            // console.log(alerts);
            // for(var i=0; i<alerts.length; i++) {
            //   var alert = {};
            //   alert = alerts[i];
            //   this.alerts.push(alert);
            // }
            this.alerts = data.notifications;
            if(this.alerts.length) {
              this.$refs["alerts-modal"].show();
            }
          } else {
            this.$swal("", "Something went wrong", "error");
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          if (error.response) {
            if (error.response.status == 422) {
              if (error.response.data) {
                this.errors = error.response.data.message;
              }
              this.$swal("", error.response.statusText, "error");
            } else if (error.response.status == 500) {
              this.$swal("", error.response.statusText, "error");
            } else if (error.response.status == 401) {
              this.$swal("", error.response.statusText, "error");
              this.$router.push({ name: "login" });
            } else {
              this.$swal("", "Something went wrong", "error");
            }
          } else {
            this.$swal("", error.message, "error");
          }
        });
    },
  },
};
</script>

<style type="text/css">
   /* Hide close button of info window */
   button.gm-ui-hover-effect {
       visibility: hidden;
   }
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mb-4">
      <div class="col-md-4">
        <Stat icon="fas fa-user" title="Customers" :value="total_customers" />
      </div>

      <div class="col-md-4">
        <Stat icon="fas fa-user-tie" title="Drivers" :value="total_drivers" />
      </div>

      <div class="col-md-4">
        <Stat
          icon="fas fa-gas-pump"
          title="Fuel Stations"
          :value="total_fuel_stations"

        />
      </div>

      <div class="col-md-4">
        <Stat
          icon="fas fa-shopping-cart"
          title="Total Orders"
          :value="total_orders"
        />
      </div>

      <div class="col-md-4">
        <Stat

          icon="fas fa-file-alt"
          title="Total Sales"
          :value="'$' + total_sales"
        />
      </div>

      <div class="col-md-4">
        <Stat
          icon="fas fa-hand-holding-usd"
          title="Total Earnings"
          :value="'$' + total_earnings"
        />
      </div>

      <div class="col-md-4">
        <Stat
          icon="fas fa-shopping-cart"
          title="Today's Orders"
          :value="today_orders"
        />
      </div>

      <!-- <div class="col-md-4">
        <Stat
          icon="fas fa-shopping-cart"
          title="This Week's Orders"
          :value="total_orders_week"
        />
      </div> -->      

      <div class="col-md-4">
        <Stat
          icon="fas fa-shopping-cart"
          title="This Month's Orders"
          :value="total_orders_month"
        />
      </div>

      <div class="col-md-4">
        <a href="javascript: void(0);"  @click.prevent="fetchAlerts()">
        <Stat icon="fas fa-duotone fa-bell" title="Alerts!" :value="alerts_count" /></a>
      </div>
    </div>
    <!-- end row -->


    <div class="row mb-5"  v-if="this.locations.length">
      <div class="col-12">
        <gmap-map :center="center" :zoom="10" style="width: 100%; height: 400px">
            <gmap-marker 
               :key="index" 
               v-for="(gmp, index) in locations"
               :icon="markerOptions"
               :position="gmp.position"
               @click="center = gmp" 
               :label="gmp.label"
               @mouseover="showByIndex = index;"
               @mouseout="showByIndex = null"
            >
               <gmap-info-window 
                  :options="gmp.tooltip"
                  :opened="showByIndex === index"
               ><!-- Your HTML --></gmap-info-window> 
          </gmap-marker>
        </gmap-map>
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="font-size-20 p-3 mb-3">Order Status</h4>
            <apexchart
              v-if="pieChart.series.length"
              class="apex-charts"
              height="320"
              type="pie"
              dir="ltr"
              :series="pieChart.series"
              :options="pieChart.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="font-size-20 p-3 mb-3">Monthly Orders</h4>
                  <apexchart  v-if="splineAreaChart.series[0].data.length"
              class="apex-charts"
              height="350"
              type="area"
              dir="ltr"
              :series="splineAreaChart.series"
              :options="splineAreaChart.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <div class="row mb-5">
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="font-size-20 p-3 mb-3">
              Monthly Customer Registrations
            </h4>
                  <apexchart  v-if="splineAreaChart2.series[0].data.length"
              class="apex-charts"
              height="350"
              type="area"
              dir="ltr"
              :series="splineAreaChart2.series"
              :options="splineAreaChart2.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="font-size-20 p-3 mb-3">Fuel Orders</h4>
            <apexchart
              v-if="pieChart2.series.length"
              class="apex-charts"
              height="320"
              type="pie"
              dir="ltr"
              :series="pieChart2.series"
              :options="pieChart2.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>

    <!---- modal starts ---->
      <b-modal ref="alerts-modal" id="alerts-modal" title="Alerts" hide-footer>
      
        <div class="d-flex mb-2" v-for="alert in alerts" :key="alert.id">

            <!-- <div class="avatar-xs align-self-center me-3">
              <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">{{ alert.name_en.charAt(0).toUpperCase() }}</span>

            </div> -->
            <div class="avatar-xs me-3">
                  <span
                    class="avatar-title bg-soft bg-primary rounded-circle font-size-16"
                  >
                    <i class="fas fa-exclamation"></i>
                  </span>
            </div>

            <div class="flex-grow-1" style="max-width:400px;">
              <h6 class="mt-0 mb-1">
                {{ alert.title_en }}
              </h6>
              <div class="font-size-12 text-muted">
                <p class="mb-1">
                  {{ alert.description_en }}
                </p>
                <p class="mb-0">
                  <i class="mdi mdi-clock-outline"></i>
                  {{ alert.created_at | formatDateTime }}
                </p>
              </div>
            </div>
        </div>
      </b-modal>
    <!---- modal ends ----->
  </Layout>
</template>
